import React from "react";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import TabbedHeader from "../../../../Utils/layout/components/header/TabbedHeader/TabbedHeader";
import * as helpers from "../../../util/helpers";
import { useMobileViewport } from "../../../util/mobileViewPort";
import { setSettingsPageTabIndex } from "../../Settings/state/slices/campaignSlice";

const configurationTabLabelsMap = {
  createcampaign: "Create Campaign",
  campaign: "Campaign",
};

const CampaignHeader = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const selectedTab = useSelector((state) => state.campaignSlice.activeTab);

//   const isFeatureEnabled = (feature) => {
//     return helpers.isFeatureEnabled(feature);
//   };

  const settingsTabPaths = [
    ...((true && ["createcampaign"]) || []),
    ...((true && ["campaign"]) || []),
  ];

  const splitLocationPathname = useCallback(() => {
    return location.pathname.split("/")[1];
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname) {
      Object.keys(settingsTabPaths).forEach((path, index) => {
        if (configurationTabLabelsMap[splitLocationPathname()]) {
          if (splitLocationPathname() === settingsTabPaths[index]) {
            handleOnTabChange(null, index);
          } else {
            if (!settingsTabPaths.includes(splitLocationPathname())) {
              history.push(`/`);
            }
          }
        }
      });
    }
  }, [splitLocationPathname]);

  const handleOnTabChange = (event, newValue) => {
    dispatch(setSettingsPageTabIndex(newValue));
    history.push(`/${settingsTabPaths[newValue]}`);
    if (event) {
    //   Tracker.event(
    //     "Hook API",
    //     `Click`,
    //     "Hook API Click top bar",
    //     "",
    //     helpers.getUser()
    //   );
    }
  };

  return (
    <div className="d-flex flex-grow-1">
      {!useMobileViewport() && (
        <TabbedHeader
          value={selectedTab}
          ariaLabel="settings"
          handleChange={handleOnTabChange}
          tabList={[
            ...((true && ["Create Campaign"]) || []),
            ...((true && ["Campaign"]) || [])
          ]}
        />
      )}
    </div>
  );
};

export default CampaignHeader;
